var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('template-header'),_c('template-hero'),_c('template-breadcrumb'),_vm._m(0),_c('template-cart'),_c('template-footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(" Your Cart: 2 Items ")])])
}]

export { render, staticRenderFns }